import { EXTENDED_FIELD_DRAWER_DEFAULT } from "us.collection.admin/constants";
import { ExtendedFieldState } from "us.collection.admin/interfaces";

export const initialState: ExtendedFieldState = {
  fields: {
    isLoading: false,
    data: [],
  },
  storedProcedures: {
    isLoading: false,
    data: [],
  },
  dataTypes: {
    isLoading: false,
    data: [],
  },
  isFieldDeleting: false,
  isFieldSaving: false,
  drawerInfo: EXTENDED_FIELD_DRAWER_DEFAULT,
};
